// import axios from 'axios';
import { YoudaoResponse } from '../base/define';
import { PandaUserLoginInfo, YouDaoUser } from './define';
import { Order } from '../order/define';
import { ROLES, SUBJECT_ROLES } from '../team/define';
import UserCache from './cache';

export const formatYoudaoUser = (data: YoudaoResponse<YouDaoUser>) => {
  if (data.code === 0) {
    return data.data;
  }
  return {};
};

export const formatLoginPanda = (res: PandaUserLoginInfo) => {
  if (res?.userInfo?.uid) {
    window.PandaNamespace.isLogin = true;
    // window.PandaNamespace.token = res.token;  // getUserInfo 中不返回 token，后端去掉了 token 校验
    window.PandaNamespace.userInfo = res.userInfo;
    window.PandaNamespace.userAccount = res.userAccount;
    window.PandaNamespace.teamInfo = res.teamInfo;
    window.PandaNamespace.isBindWeChat = !!res.isBindWeChat;
    // axios.defaults.headers.common['PANDA-TOKEN'] = window.PandaNamespace.token;
    window.PandaNamespace.isRestrictedAccess = UserCache.hasPermission([ROLES.OUTSIDE_SALES]);
    window.PandaNamespace.isPartialAccess = UserCache.hasPermission(SUBJECT_ROLES);
  }

  return res;
};

export const formatOrderArray = (data: Array<Order>) => {
  const array = data.map((serverOrder: Order) => {
    const order = { ...serverOrder };
    order.payAmount = serverOrder.payAmount / 100;
    return order;
  });
  return array;
};
